import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import StepShell from "./StepShell";
import copy from "../copy";

// Spanish numbers: country code 34 + 9 digits starting with 6, 7, 8 or 9.
const PHONE_RE = /^34[6-9]\d{8}$/;

const PhoneStep = ({ data, handleChange, onNext, onBack }) => {
  const [touched, setTouched] = useState(false);
  const phone = data.phone || "34";
  const valid = PHONE_RE.test(phone);

  const onChange = (value) => {
    let digits = (value || "").replace(/\D/g, "");
    if (!digits.startsWith("34")) digits = "34" + digits;
    handleChange("phone", digits.slice(0, 11));
  };

  const showError = touched && phone.length > 2 && !valid;

  return (
    <StepShell onBack={onBack}>
      <p className="rp-subtitle rp-phone-lead">
        <strong>{copy.phone.leadBold}</strong>
        {copy.phone.lead}
      </p>
      <form
        className="rp-form rp-phone"
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          if (valid) onNext();
        }}
      >
        <PhoneInput
          country="es"
          onlyCountries={["es"]}
          disableDropdown
          countryCodeEditable={false}
          value={phone}
          onChange={onChange}
          onBlur={() => setTouched(true)}
          inputProps={{
            name: "phone",
            required: true,
            autoComplete: "tel-national",
            "aria-label": copy.phone.label,
          }}
        />
        {showError && <p className="rp-error">{copy.phone.invalid}</p>}
        <p className="rp-hint">{copy.phone.note1}</p>
        <p className="rp-hint">{copy.phone.note2}</p>
        <div className="rp-actions">
          <button type="submit" className="rp-btn" disabled={!valid}>
            {copy.next}
          </button>
        </div>
      </form>
    </StepShell>
  );
};

export default PhoneStep;
